import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { classNames } from 'uitk-react-utils';

interface MesoDisplayAdProps {
  uci: string;
  className?: string;
}

export const MesoDisplayAd: React.FunctionComponent<MesoDisplayAdProps> = props => {
  const displayAd = React.useRef(null);

  const className = classNames('ad-div', 'display-ad', {
    [props.className]: props.className
  });

  return (
    <ErrorBoundary label="meso.display.ad">
      <meso-display-ad ref={displayAd} uci={props.uci} class={className} />
    </ErrorBoundary>
  );
};
MesoDisplayAd.displayName = 'MesoDisplayAd';
